import { defineNuxtPlugin } from '#app/nuxt'
import { LazyCampaignsList, LazyCenteredBlocksList, LazyCenteredContent, LazyCustomSwiper, LazyCustomSwiperSlide, LazyDoubleColBlock, LazyDoubleColList, LazyFullImageTitleText, LazyFullSwiper, LazyFullSwiperSlide, LazyGallery, LazyGallerySlide, LazyGeneralHeader, LazyIconSectionIconSlide, LazyIconSection, LazyImageTextLinkSwiper, LazyImageTextLinkSwiperSlide, LazyImageTextSwiper, LazyImageTextSwiperSlide, LazyIntroTextImage, LazyTextImageWithBg, LazyTextImage, LazyTimeline, LazyTitleText } from '#components'
const lazyGlobalComponents = [
  ["CampaignsList", LazyCampaignsList],
["CenteredBlocksList", LazyCenteredBlocksList],
["CenteredContent", LazyCenteredContent],
["CustomSwiper", LazyCustomSwiper],
["CustomSwiperSlide", LazyCustomSwiperSlide],
["DoubleColBlock", LazyDoubleColBlock],
["DoubleColList", LazyDoubleColList],
["FullImageTitleText", LazyFullImageTitleText],
["FullSwiper", LazyFullSwiper],
["FullSwiperSlide", LazyFullSwiperSlide],
["Gallery", LazyGallery],
["GallerySlide", LazyGallerySlide],
["GeneralHeader", LazyGeneralHeader],
["IconSectionIconSlide", LazyIconSectionIconSlide],
["IconSection", LazyIconSection],
["ImageTextLinkSwiper", LazyImageTextLinkSwiper],
["ImageTextLinkSwiperSlide", LazyImageTextLinkSwiperSlide],
["ImageTextSwiper", LazyImageTextSwiper],
["ImageTextSwiperSlide", LazyImageTextSwiperSlide],
["IntroTextImage", LazyIntroTextImage],
["TextImageWithBg", LazyTextImageWithBg],
["TextImage", LazyTextImage],
["Timeline", LazyTimeline],
["TitleText", LazyTitleText],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
